import { useState } from 'react';
import { motion } from 'framer-motion';
import { format, addDays, isSameDay } from 'date-fns';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './DiaryTimeline.css';

const DiaryTimeline = ({ entries }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  
  const formatDate = (timestamp) => {
    if (!timestamp) return '';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return format(date, 'MMM d');
  };

  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return format(date, 'h:mm a');
  };

  const handlePrevDay = () => {
    setSelectedDate(prev => addDays(prev, -1));
  };

  const handleNextDay = () => {
    const tomorrow = addDays(new Date(), 1);
    if (selectedDate < tomorrow) {
      setSelectedDate(prev => addDays(prev, 1));
    }
  };

  const filteredEntries = entries.filter(entry => {
    if (!entry || !entry.createdAt) return false;
    const entryDate = entry.createdAt.toDate();
    return isSameDay(entryDate, selectedDate);
  });

  const isToday = isSameDay(selectedDate, new Date());
  const canGoForward = !isSameDay(selectedDate, new Date());

  return (
    <div className="diary-container">
      <div className="diary-header">
        <h2>Journal Entries</h2>
        <div className="date-selector">
          <button 
            className="date-nav-button"
            onClick={handlePrevDay}
            aria-label="Previous day"
          >
            <FaChevronLeft />
          </button>
          <div className="selected-date">
            <span className="date">{format(selectedDate, 'MMM d')}</span>
          </div>
          <button 
            className="date-nav-button"
            onClick={handleNextDay}
            disabled={isToday}
            aria-label="Next day"
          >
            <FaChevronRight />
          </button>
        </div>
      </div>

      <div className="diary-timeline">
        <div className="timeline-entries">
          {filteredEntries.map((entry) => (
            <motion.div 
              key={entry.id}
              className="timeline-entry"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
            >
              <div className="entry-date">
                <span className="date">{formatDate(entry.createdAt)}</span>
                <span className="time">{formatTime(entry.createdAt)}</span>
              </div>
              <div className="entry-content">
                <p>{entry.text}</p>
              </div>
            </motion.div>
          ))}
          {filteredEntries.length === 0 && (
            <div className="no-entries">
              <p>{isToday ? 
                "No journal entries yet. Start writing your thoughts!" : 
                "No entries for this day."
              }</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DiaryTimeline;